import { useTheme } from 'styled-components';
import type { IconComponent } from '../../themes/base/icons/types';
import { Root, SvgWrapper } from './icon.styles';

export interface IconProps {
    icon: IconComponent;
    size?: number; // the actual icon (svg) size
    color?: string;
    background?: string; // circle color
    backgroundSize?: number; // diameter of that circle
}
export function Icon({ icon: SvgIcon, size = 32, color, background, backgroundSize }: IconProps) {
    const theme = useTheme();
    const bgSize = backgroundSize ?? size;
    return (
        <Root $background={background} $backgroundSize={bgSize} $iconSize={size}>
            <SvgWrapper $size={size}>
                <SvgIcon color={color ?? theme.colorPrimary} />
            </SvgWrapper>
        </Root>
    );
}
